<mat-sidenav-container class="mainWrapper blue_theme light-theme" autosize dir="ltr"   (backdropClick)="onBackdropClick()">

    <mat-sidenav
    #leftsidenav
    [mode]="isOver ? 'over' : 'side'"
   [(opened)]="sidenavOpened"
    class="sidebarNav"
    [class.collapsed]="isCollapsed"
    [disableClose]="true"
  >
    <app-sidebar [collapsed]="isCollapsed" (collapsedChange)="isCollapsed = $event"></app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content class="contentWrapper">
    <app-header
      [showToggle]="!isOver"
      (toggleCollapsed)="toggleCollapseds()"
      (toggleMobileNav)="sidenav.toggle()"
    ></app-header>
    <main class="pageWrapper">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>